export const ZEFFY_URL = "https://www.zeffy.com/en-CA/donation-form/contribute-to-change";
export const INSTAGRAM_URL = "https://www.instagram.com/changeforcongo";
export const WELLNESS_URL = "https://www.nseyawellness.com";
export const CONTACT_EMAIL = "info@nseyafoundation.org";
export const WELLNESS_NOTE =
  "50% of proceeds from the Nseya Wellness Retreat go directly to the Nseya Humanitarian Foundation. When you invest in your wellness, you invest in others. Learn more at www.nseyawellness.com";

const u = (id, w = 1600) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  heroForest: u("photo-1761998849345-7757a8c3b818", 2400),
  forestBank: u("photo-1761998849496-9b2c0822dc07"),
  riverVillage: u("photo-1761998940222-a9c2d2d8c7ab"),
  riverRaft: u("photo-1761998940168-5c881d58b6c1"),
  borehole: u("photo-1601662583487-20630f298aed"),
  waterHands: u("photo-1546531130-0f36255d9d49"),
  jerrycans: u("photo-1543180930-261980d4868a"),
  womenJoy: u("photo-1509099863731-ef4bff19e808"),
  womenGathering: u("photo-1509099955921-f0b4ed0c175c"),
  womanTurban: u("photo-1505421031134-e57263cae630"),
  childrenGroup: u("photo-1509099836639-18ba1795216d"),
  classroom: u("photo-1567057419565-4349c49d8a04"),
  classroom2: u("photo-1473649085228-583485e6e4d7"),
  smilingChildren: u("flagged/photo-1555251255-e9a095d6eb9d"),
  farmerPlanting: u("photo-1509099381441-ea3c0cf98b94"),
  farmerField: u("photo-1615137705646-cd4c2a4c0ca0"),
  womanFarming: u("photo-1509100194014-d49809396daa"),
  danceCircle: u("photo-1515658323406-25d61c141a6e"),
  danceJoy: u("photo-1515657834497-26509e295154"),
  drum: u("photo-1505147634308-9b83c4cb46b4"),
  danceTraditional: u("photo-1660675133902-acd1b057f75d"),
  wellnessRock: u("photo-1695795910772-6336b0beba36"),
  wellnessDock: u("photo-1600618528240-fb9fc964b853"),
  wellnessGroup: u("photo-1644612105654-b6b0a941ecde"),
  wellnessYoga: u("photo-1506126613408-eca07ce68773"),
  childrenCircle: u("photo-1658129850537-ea7517a9682f"),
  communityCrowd: u("photo-1781263378223-1e09658a7567"),
  minerDigging: "/brand/miners-tunnel.jpg",
  textiles: u("photo-1552710307-537199cd41c0"),
  textilesStack: u("photo-1578509566163-068acd11b8e7"),
  womenCrafting: u("photo-1757085242641-d829ddde7191"),
  artHealing: u("photo-1757085242652-f8cd4d3de889"),
  masterplan: "/brand/sanctuary-masterplan.png",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Get Involved", to: "/get-involved" },
  { label: "Contact", to: "/contact" },
];

export const MARQUEE_ITEMS = [
  "Safety",
  "Dignity",
  "Clean Water",
  "Community",
  "Healing",
  "Education",
  "Sustainability",
  "Culture",
];

export const WHY_CONGO = [
  {
    key: "forest",
    title: "The Forest",
    sub: "Congo Basin rainforest and biodiversity",
    body: "The Congo Basin is one of the world's most important tropical forest ecosystems and plays a major role in regulating climate and supporting extraordinary biodiversity — much of it found nowhere else on Earth.",
    img: IMG.forestBank,
  },
  {
    key: "water",
    title: "The Water",
    sub: "The Congo River and freshwater resources",
    body: "The Congo River is among the largest rivers on Earth by volume. Its vast freshwater systems sustain communities, forests and wildlife across Central Africa.",
    img: IMG.riverRaft,
  },
  {
    key: "minerals",
    title: "The Minerals",
    sub: "Resources important to modern industry",
    body: "Cobalt, copper, coltan/tantalum, gold, tin, tungsten and other resources — many essential to the batteries, wiring and technology of modern life.",
    img: IMG.minerDigging,
  },
  {
    key: "people",
    title: "The People",
    sub: "Communities connected to these resources",
    body: "Communities whose lives, labor and cultures are connected to these resources — people who deserve safety, opportunity and a share in the wealth their land creates.",
    img: IMG.womenJoy,
  },
  {
    key: "culture",
    title: "The Culture",
    sub: "Music, dance, food, art, language, spirituality, history and diaspora",
    body: "Congolese music, dance and art have shaped generations of African and global culture. This is a living heritage — joyous, resilient and endlessly creative.",
    img: IMG.danceCircle,
  },
];

export const HUMAN_CHALLENGES = [
  "Unsafe working conditions in some mining communities",
  "Lack of protective equipment",
  "Limited access to healthcare",
  "Limited clean water",
  "Unsafe housing",
  "Poverty and displacement",
  "Exploitation",
  "Gender-based violence",
  "Sexual violence against women and girls",
  "Limited economic opportunities",
  "Environmental degradation",
];

export const WATER_ITEMS = [
  "Water wells",
  "Boreholes",
  "Filtration",
  "Water tanks",
  "Piping",
  "Hygiene",
  "Sanitation",
  "Well-digging equipment",
  "Maintenance",
  "Community involvement",
];

export const CARE_STAGES = [
  { title: "Care", desc: "Medical + wellness" },
  { title: "Safety", desc: "Housing + protection" },
  { title: "Healing", desc: "Wellness + community" },
  { title: "Education", desc: "Children + learning" },
  { title: "Skills", desc: "Trades + vocational training" },
  { title: "Sustainability", desc: "Agriculture + water + energy" },
  { title: "Independence", desc: "Income + enterprise + community" },
];

export const SANCTUARY_COMPONENTS = [
  { n: 1, title: "Security & Entrance", desc: "Gate, guard post and perimeter fencing.", pos: { x: 31.2, y: 57.6 } },
  { n: 2, title: "Administration & Welcome Center", desc: "Offices, reception and meeting space.", pos: { x: 33.2, y: 22 } },
  { n: 3, title: "Medical Facility", desc: "Clinic, maternity care, pharmacy and counseling rooms.", pos: { x: 30, y: 34.2 } },
  { n: 4, title: "Women's Housing", desc: "Safe and private housing designed around dignity and recovery.", pos: { x: 11.4, y: 24.9 } },
  { n: 5, title: "Children's Facility", desc: "Childcare, dormitory and family-style spaces, play and recreation.", pos: { x: 20.2, y: 19 } },
  { n: 6, title: "Community Center", desc: "Gathering, dining, events and community activities.", pos: { x: 26, y: 24.4 } },
  { n: 7, title: "School & Education Center", desc: "Classrooms, learning spaces and technology.", pos: { x: 51, y: 26.9 } },
  { n: 8, title: "Vocational & Trades School", desc: "Sewing, tailoring, music, carpentry, arts, crafts and other locally appropriate skills.", pos: { x: 7.5, y: 39 } },
  { n: 9, title: "Agriculture & Farming", desc: "Crops, gardens, permaculture and livestock where appropriate.", pos: { x: 32, y: 43.5 } },
  { n: 10, title: "Greenhouse & Nursery", desc: "Seedlings, vegetables and fruit trees.", pos: { x: 53, y: 38.6 } },
  { n: 11, title: "Water System", desc: "Borehole, elevated tank, filtration and distribution.", pos: { x: 34.2, y: 12.7 } },
  { n: 12, title: "Solar Energy", desc: "Solar panels and energy storage.", pos: { x: 48, y: 49.3 } },
  { n: 13, title: "Markets & Business Hub", desc: "Local products, workshops and income-generating activities.", pos: { x: 46.7, y: 19.5 } },
];

export const PILLARS = [
  { title: "Care", desc: "Medical and wellness support that meets people with compassion first." },
  { title: "Safety", desc: "Safe housing and protection designed around dignity." },
  { title: "Food", desc: "Gardens, crops and livestock grown locally." },
  { title: "Skills", desc: "Trades and training that open real opportunity." },
  { title: "Income", desc: "Enterprise and markets that sustain the community." },
];

export const PROJECTS = [
  { title: "Clean Water", desc: "Wells, boreholes, filtration, tanks, piping, sanitation and maintenance.", img: IMG.borehole, cta: "Support Clean Water" },
  { title: "Women & Children", desc: "Protection, safe spaces, medical and wellness support, nutrition and community resources.", img: IMG.womenGathering, cta: "Support the Sanctuary" },
  { title: "Miner Support", desc: "Protective equipment, boots, gloves, tools, clothing and essential resources — delivered with dignity, standing with miners as workers, not victims.", img: IMG.minerDigging, cta: "Support Miner Safety" },
  { title: "Housing & Safe Shelter", desc: "Durable homes, roofing, construction materials, community spaces and safe housing.", img: IMG.riverVillage, cta: "Support Safe Housing" },
  { title: "Agriculture & Food Security", desc: "Gardens, crops, fruit trees, permaculture and locally appropriate agriculture.", img: IMG.farmerPlanting, cta: "Support Food Security" },
  { title: "Education & Youth", desc: "School supplies, uniforms, educational resources, safe learning spaces and youth development.", img: IMG.classroom, cta: "Support Education" },
  { title: "Vocational & Economic Empowerment", desc: "Sewing, tailoring, carpentry, crafts, agriculture, entrepreneurship and other skills.", img: IMG.womenCrafting, cta: "Support Skills & Income" },
  { title: "Environment & Community", desc: "Supporting community-led environmental stewardship and sustainable practices, rooted in local knowledge.", img: IMG.forestBank, cta: "Support Community Stewardship" },
];

export const SUPPORT_GOES = [
  { title: "Clean Water", desc: "Wells, water infrastructure, filtration, equipment and maintenance." },
  { title: "Medical & Wellness", desc: "Healthcare-related support, wellness initiatives and community resources." },
  { title: "Women & Children", desc: "Safe spaces, protection, housing and support." },
  { title: "Community", desc: "Essential supplies and community development." },
  { title: "Education", desc: "School resources, youth support and skills development." },
  { title: "Sanctuary Development", desc: "Long-term planning and development toward the Women & Children's Sanctuary." },
];

export const INVOLVE_CARDS = [
  { title: "Donate", desc: "Support projects and the sanctuary vision.", icon: "heart" },
  { title: "Volunteer", desc: "Offer your skills, time or expertise.", icon: "hand" },
  { title: "Attend", desc: "Join wellness retreats, workshops and cultural events.", icon: "calendar" },
  { title: "Partner", desc: "Collaborate with Nseya on projects and community initiatives.", icon: "users" },
  { title: "Advocate", desc: "Learn, share and help bring greater awareness to Congo.", icon: "megaphone" },
  { title: "Fundraise", desc: "Create your own fundraiser or community event.", icon: "coins" },
];

export const STORIES = [
  {
    category: "Water",
    title: "From the First Well — Field Notes",
    excerpt: "Notes and images from the ground as our first water projects move from planning toward reality.",
    img: IMG.waterHands,
  },
  {
    category: "Sanctuary",
    title: "Designing for Dignity: Inside the Sanctuary Vision",
    excerpt: "Why the sanctuary begins with care — and how a master plan slowly becomes a community.",
    img: IMG.childrenCircle,
  },
  {
    category: "Dance for Congo",
    title: "Dance for Congo: Rhythm, Culture & Purpose",
    excerpt: "A cultural experience exploring movement, music and the traditions connected to Congo — and what they make possible.",
    img: IMG.danceJoy,
    comingSoon: false,
  },
];

export const BOARD = [
  {
    name: "Lunzaya Nlandu",
    role: "Board Member",
    bio: "A proud member of the Congolese diaspora with deep roots in community advancement and youth empowerment. A former college-level basketball athlete, he brings discipline, leadership and a results-oriented perspective to the Nseya Foundation board.",
    bio2: "As founder of LZ Entertainment, he has helped create platforms connecting international artists and African talent with audiences in Canada. His commitment to elevating Congolese communities and strengthening the global diaspora contributes to the foundation's mission.",
  },
  {
    name: "Rani Ladha",
    role: "Board Member",
    bio: "Born in Rwanda and a survivor of the 1994 genocide, Rani brings lived experience and a deep commitment to humanitarian work and community rebuilding.",
    bio2: "With experience in administration, event planning and project coordination, she brings structure, organization and compassion to the Nseya Foundation. Living in the diaspora, she contributes her experience to initiatives focused on dignity, safety and support for vulnerable communities.",
  },
];
